import "./globals.css";
import "antd/dist/reset.css";
import "react-quill/dist/quill.snow.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import {
  LogingSuccessPage,
  SignInPage,
  PaymentProccessPage,
  PaymentHistoryPage,
  ManageCustomerPage,
  RemittancePage,
  ReportByCustomer,
  ReportByDate,
  ReportByInquery,
  ReportByRemittance,
  SystemLogs,
  ManageUser,
  ManageDealers,
  ManageVehicle,
  VehicleConfig,
  ManageStockTransfer,
  DealerMonitor,
  VehicleHistory,
  StockTransferHistory,
  StockReports,
  FinancialReports,
  DpmcRemittanceReport,
  SalesInvoiceBreakdown,
  DaySummary,
  BankManagement,
  ManageTicketsPage,
  Dashboard,
  ManageSalesPersons,
  TriggeredEmails,
  ManageCredit,
  ManageGrnPage,
  ReturnedVehiclesReport,
  ManageProductsPage,
  OfferForInquiry,
  ReportBySalesPerson,
  SalesReportBikeThreewheel,
  CustomReports,
  NodeReports,
} from "./Page";
import {
  LOGIN_SUCCESS,
  MANAGE_CUSTOMERS,
  MANAGE_DEALERS,
  MANAGE_USERS,
  MANAGE_VEHICLE,
  PAYMENT_HISTORY,
  PAYMENT_PROCCESS,
  REMITTANCE,
  REPORT_BY_CUSTOMER,
  REPORT_BY_DATE,
  REPORT_BY_INQUERY,
  REPORT_BY_REMITTANCE,
  SYSTEM_LOGS,
  VEHICLE_CONFIG,
  REPORT_BY_SALES_PERSON,
  MANAGE_STOCK_TRANSFER,
  DEALER_MONITOR,
  VEHICLE_HISTORY,
  STOCK_TRANSFER_HISTORY,
  STOCK_REPORTS,
  FINANCIAL_REPORTS,
  DPMC_REMITTANCE_REPORT,
  SALES_INVOICE_BREAKDOWN,
  DAY_SUMMARY,
  MANAGE_BANK,
  MANAGE_TICKETS,
  DASHBOARD,
  MANAGE_SALES_PERSONS,
  TRIGGERED_EMAILS,
  MANAGE_CREDIT,
  MANAGE_GRN,
  RETURNED_VEHICLE_REPORT,
  MANAGE_PRODUCTS,
  OFFER_FOR_INQUIRY,
  REPORT_BIKE_THREEWHEEL,
  CUSTOM_REPORTS,
  NODE_REPORTS,
  SUB_DEALER_CASH_REPORT,
} from "./Constant";
import { SidebarProvider } from "./components/ui/sidebar";
import { AppSidebar } from "./components/side-bar/AppSidebar";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route
            path={"/*"}
            element={
              <>
                <Routes>
                  <Route path={"/"} element={<SignInPage />} />
                  <Route path={LOGIN_SUCCESS} element={<LogingSuccessPage />} />
                </Routes>
              </>
            }
          />

          <Route
            path={"/admin/*"}
            element={
              <>
                <SidebarProvider>
                  <AppSidebar />
                  {/* <AiBot /> */}
                  <Routes>
                    <Route path={DASHBOARD} element={<Dashboard />} />
                    <Route
                      path={PAYMENT_PROCCESS}
                      element={<PaymentProccessPage />}
                    />
                    <Route
                      path={PAYMENT_HISTORY}
                      element={<PaymentHistoryPage />}
                    />
                    <Route
                      path={MANAGE_CUSTOMERS}
                      element={<ManageCustomerPage />}
                    />
                    <Route path={REMITTANCE} element={<RemittancePage />} />
                    <Route
                      path={REPORT_BY_CUSTOMER}
                      element={<ReportByCustomer />}
                    />
                    <Route path={REPORT_BY_DATE} element={<ReportByDate />} />
                    <Route
                      path={REPORT_BY_SALES_PERSON}
                      element={<ReportBySalesPerson />}
                    />
                    <Route
                      path={REPORT_BIKE_THREEWHEEL}
                      element={<SalesReportBikeThreewheel />}
                    />
                    <Route
                      path={REPORT_BY_INQUERY}
                      element={<ReportByInquery />}
                    />
                    <Route
                      path={REPORT_BY_REMITTANCE}
                      element={<ReportByRemittance />}
                    />
                    <Route path={SYSTEM_LOGS} element={<SystemLogs />} />
                    <Route path={MANAGE_USERS} element={<ManageUser />} />
                    <Route path={MANAGE_DEALERS} element={<ManageDealers />} />
                    <Route path={MANAGE_VEHICLE} element={<ManageVehicle />} />
                    <Route path={VEHICLE_CONFIG} element={<VehicleConfig />} />
                    <Route path={MANAGE_GRN} element={<ManageGrnPage />} />
                    <Route
                      path={MANAGE_STOCK_TRANSFER}
                      element={<ManageStockTransfer />}
                    />
                    <Route path={DEALER_MONITOR} element={<DealerMonitor />} />
                    <Route
                      path={VEHICLE_HISTORY}
                      element={<VehicleHistory />}
                    />
                    <Route
                      path={STOCK_TRANSFER_HISTORY}
                      element={<StockTransferHistory />}
                    />
                    <Route path={STOCK_REPORTS} element={<StockReports />} />
                    <Route
                      path={FINANCIAL_REPORTS}
                      element={<FinancialReports />}
                    />
                    <Route
                      path={DPMC_REMITTANCE_REPORT}
                      element={<DpmcRemittanceReport />}
                    />
                    <Route
                      path={SALES_INVOICE_BREAKDOWN}
                      element={<SalesInvoiceBreakdown />}
                    />
                    <Route path={DAY_SUMMARY} element={<DaySummary />} />
                    <Route path={MANAGE_BANK} element={<BankManagement />} />
                    <Route
                      path={MANAGE_TICKETS}
                      element={<ManageTicketsPage />}
                    />
                    <Route
                      path={MANAGE_SALES_PERSONS}
                      element={<ManageSalesPersons />}
                    />
                    <Route
                      path={TRIGGERED_EMAILS}
                      element={<TriggeredEmails />}
                    />
                    <Route path={MANAGE_CREDIT} element={<ManageCredit />} />
                    <Route
                      path={RETURNED_VEHICLE_REPORT}
                      element={<ReturnedVehiclesReport />}
                    />
                    <Route
                      path={MANAGE_PRODUCTS}
                      element={<ManageProductsPage />}
                    />
                    <Route
                      path={OFFER_FOR_INQUIRY}
                      element={<OfferForInquiry />}
                    />
                    <Route
                      path={CUSTOM_REPORTS}
                      element={<CustomReports />}
                    />
                    <Route
                      path={NODE_REPORTS}
                      element={<NodeReports />}
                    />
                    <Route
                      path={SUB_DEALER_CASH_REPORT}
                      element={<FinancialReports />}
                    />
                  </Routes>
                </SidebarProvider>
              </>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
